<template>
  <div>

    <vs-table id="sundry-order-item-table" :hoverFlat="true" :data="sundry_items">

      <template slot="thead">
        <vs-th class="text-sm" width="10%">ITEM CODE</vs-th>
        <vs-th class="text-sm" width="10%">PRODUCT NAME</vs-th>
        <vs-th class="text-sm" width="5%">SOLD IN</vs-th>
        <vs-th class="text-sm" width="10%">QUANTITY</vs-th>
        <vs-th class="text-sm" width="10%">UNIT PRICE ({{ sundry_supplier_currency }})</vs-th>
        <vs-th width="10%" class="text-xs">QC STATUS</vs-th>
        <vs-th class="text-sm" width="10%">PAYMENT STATUS</vs-th>
        <vs-th class="text-sm" width="10%">ITEM STATUS</vs-th>
        <vs-th width="10%" class="text-sm">TOTAL PRICE Excl VAT ({{ sundry_supplier_currency }})</vs-th>
        <vs-th class="text-sm" width="10%">TOTAL VAT (GBP)</vs-th>
        <vs-th width="10%" class="text-sm">TOTAL PRICE Incl VAT ({{ sundry_supplier_currency }})</vs-th>
        <vs-th class="text-sm" width="5%">ACTIONS</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

          <vs-td :data="data[indextr].sundry_item_code">
            {{ data[indextr].sundry_item_code }}
          </vs-td>

          <vs-td :data="data[indextr].sundry_product_name">
            {{ data[indextr].sundry_product_name || '' }}
          </vs-td>

          <vs-td :data="data[indextr].sold_in">
            {{ data[indextr].sold_in }}
          </vs-td>

          <vs-td :data="data[indextr].quantity">
            {{ data[indextr].quantity }}
          </vs-td>

          <vs-td :data="data[indextr].price">
            {{ (Number(data[indextr].price)).toFixed(2) }}
          </vs-td>

          <vs-td :data="data[indextr].q_c_status">
            {{ data[indextr].q_c_status || 'N/A' }}
          </vs-td>

          <vs-td :data="data[indextr].payment_status">
            {{ data[indextr].payment_status || '' }}
          </vs-td>

          <vs-td :data="data[indextr].item_status">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <a class="flex items-center text-dark ml-1" href="#">
                <vs-chip v-if="data[indextr].item_status" style="border-radius: 0" class="text-center text-xs" transparent
                  :color="itemStatusColorFactory(data[indextr].item_status)">
                  {{ data[indextr].item_status ? data[indextr].item_status : 'Submitted' }}
                </vs-chip>
                <i class="material-icons"> expand_more </i>
              </a>
              <vs-dropdown-menu v-can="'create-edit-sundry-orders'">
                <vs-dropdown-item class="w-64" @click.prevent="onClickChangeItemStatus(data[indextr].id, status.name)"
                  v-for="status in sundry_item_order_item_statuses" v-bind:key="status.name"
                  v-if="itemStatusManager(status.name, data[indextr].item_status) && status.name !== data[indextr].item_status">
                  {{ status.name }}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-td>

          <vs-td class="" :data="data[indextr].price">
            {{ data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00' }}
          </vs-td>

          <vs-td :data="data[indextr].vat">
            {{ data[indextr].vat || '0.00' }}
          </vs-td>

          <vs-td class="" :data="data[indextr].price">
            {{ data[indextr].quantity ? Number((data[indextr].price * data[indextr].quantity) +
              data[indextr].vat).toFixed(2) : '0.00' }}
          </vs-td>

          <vs-td>
            <div class="vx-row">
              <vx-tooltip v-can="'create-edit-sundry-orders-qc-test'"
                          v-if="['Received', 'Received - QC Passed'].includes(data[indextr].item_status)"
                          class="flex justify-start mr-2" text="Manage batches & QC tests" position="top">
                <vs-button class="flex justify-end"
                           size="small" color="success" type="border" icon-pack="feather" icon="icon-git-branch"></vs-button>
              </vx-tooltip>
            </div>
          </vs-td>
          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-4/5">
              <vs-table :hoverFlat="true" class="mt-8 mb-8" :data="tr.q_c_test">

                <template slot="header">
                  <h5 class="mb-4">SUNDRY BATCH</h5>
                  <div class="flex mb-4">
                    <vx-tooltip v-can="'create-edit-sundry-orders-qc-test'"
                      v-if="Number(tr.quantity_pending_to_receive) > 0 && ['Received', 'Received - QC Passed'].includes(tr.item_status)"
                      class="flex justify-start mr-2" text="Create QC Test" position="bottom">
                      <vs-button @click.stop="onClickCreateQcTest(tr)" color="primary" size="small" type="border">Create
                        QC test for new batch</vs-button>
                    </vx-tooltip>
                  </div>
                </template>

                <template slot="thead">
                  <vs-th width="10%">DATE/TIME</vs-th>
                  <vs-th width="10%">TEST DONE BY</vs-th>
                  <vs-th width="10%">QC STATUS</vs-th>
                  <vs-th width="10%">BATCH PART NO</vs-th>
                  <vs-th width="10%">SOLD IN</vs-th>
                  <vs-th width="10%">QUANTITY</vs-th>
                  <vs-th width="10%">WAREHOUSED</vs-th>
                  <vs-th width="10%">ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="index_qc_test" v-for="(tr_qc, index_qc_test) in data">

                    <vs-td :data="tr_qc.created_at">
                      {{ __dateTimeFormatterToDate(tr_qc.created_at) }}
                    </vs-td>

                    <vs-td :data="tr_qc.done_by">
                      {{ tr_qc.done_by }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.status || 'N/A' }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.inventory_item.batch_part_no || 'N/A' }}
                    </vs-td>

                    <vs-td>
                      {{ tr.sold_in }}
                    </vs-td>

                    <vs-td>
                      {{ tr_qc.inventory_item.available_quantity || 'N/A' }}
                    </vs-td>

                    <vs-td class="text-bold">
                      {{ !!tr_qc.inventory_item.location ? 'Yes' : 'No' }}
                    </vs-td>

                    <vs-td>
                      <div class="vx-row">
                        <vx-tooltip v-can="'create-edit-sundry-orders-qc-test'" class="flex justify-start mr-2"
                          text="View qc test" position="top">
                          <vs-button class="flex justify-end" @click="onClickUpdateQcTest(tr_qc)"
                            size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip
                          v-if="Number(tr.quantity_pending_to_receive) > 0 && tr.item_status === 'Received - QC Passed' && !tr_qc.inventory_item"
                          text="Create a batch for this QC test" position="top">
                          <vs-button class="flex justify-end" @click.stop="onClickAddStock(tr, tr_qc.id)" size="small"
                            color="primary" type="border" icon-pack="feather" icon="icon-plus-square"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="tr_qc.inventory_item" text="View/Update sundry inventory item" position="top">
                          <vs-button class="flex justify-end mr-2" @click.stop="onClickViewStock(tr_qc.inventory_item.id)"
                            size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="tr_qc.inventory_item" text="Label" position="top">
                          <vs-button class="flex justify-end" @click.stop="onClickPrintLabel(tr_qc.inventory_item.id)"
                            size="small" color="danger" type="border" icon-pack="feather" icon="icon-printer"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>

                  </vs-tr>
                </template>

              </vs-table>
            </div>
          </template>

        </vs-tr>
        <vs-tr>
          <vs-td colspan="8" style="font-weight: bolder">Total</vs-td>
          <vs-td class="" style="font-weight: bolder">{{ totalCalculatorExclVat() }}</vs-td>
          <vs-td colspan="1"></vs-td>
          <vs-td class="" style="font-weight: bolder">{{ totalCalculatorInclVat() }}</vs-td>
          <vs-td colspan="2"></vs-td>
        </vs-tr>
      </template>

    </vs-table>
    <create-sundry-item-inventory-pop-up ref="createSundryItemInventoryPopUp" />
    <add-qc-test-sundry-order-item-pop-up ref="addQcTestSundryOrderItemPopUp" />
    <update-sundry-stock-pop-up v-on:refreshData="refreshData" ref="updateSundryStockPopUp"/>
    <view-qc-test-sundry-order-item-pop-up ref="viewQcTestSundryOrderItemPopUp"/>
    <sundry-order-item-label-pop-up ref="sundryOrderItemLabelPopUp"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SundrySupplierRepository = RepositoryFactory.get('sundry')
import { sundry_item_order_item_statuses } from '@/constants/statuses'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateSundryItemInventoryPopUp
  from "@/components/popups/sundry-suppliers/sundry-item-orders/CreateSundryItemInventoryPopUp";
import AddQcTestSundryOrderItemPopUp from '@/components/popups/sundry-suppliers/sundry-item-orders/qc-tests/AddQcTestSundryOrderItemPopUp.vue'
import UpdateSundryStockPopUp from '@/components/popups/inventory/stock/sundry/UpdateSundryStockPopUp.vue'
import ViewQcTestSundryOrderItemPopUp from '@/components/popups/sundry-suppliers/sundry-item-orders/qc-tests/ViewQcTestSundryOrderItemPopUp.vue'
import SundryOrderItemLabelPopUp from '@/components/popups/sundry-suppliers/sundry-item-orders/labels/SundryOrderItemLabelPopUp.vue'

export default {
  name: "ProductOrderTable",
  data() {
    return {
      sundry_item_order_item_statuses: sundry_item_order_item_statuses,
      sundry_items: this.items
    }
  },
  components: {
    CreateSundryItemInventoryPopUp,
    AddQcTestSundryOrderItemPopUp,
    UpdateSundryStockPopUp,
    ViewQcTestSundryOrderItemPopUp,
    SundryOrderItemLabelPopUp
  },
  props: {
    items: {
      type: Array,
      default: []
    },
    id: {
      default: ''
    },
    sundry_supplier_currency: {
      default: 'GBP'
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async onClickCreateQcTest(tr) {
      await this.$refs.addQcTestSundryOrderItemPopUp.openPopup(tr)
    },
    async refreshData() {
      await this.getSundryItemOrderDetails()
    },
    totalCalculatorExclVat() {
      let total = 0;
      this.sundry_items.forEach((m) => {
        if (!!m.price) {
          total = total + Number(m.price) * Number(m.quantity)
        }
      })
      return total.toFixed(2)
    },
    totalCalculatorInclVat() {
      let total = 0;
      this.sundry_items.forEach((m) => {
        if (!!m.price) {
          total = total + ((Number(m.price) * Number(m.quantity)) + Number(m.vat))
        }
      })
      return total.toFixed(2)
    },
    itemStatusManager(status, current_status) {
      // let current_id = 0
      // if (!!current_status) {
      //   current_id = this.sundry_item_order_item_statuses.find((n) => n.name === current_status).id
      // }
      // const id = this.sundry_item_order_item_statuses.find((n) => n.name === status).id
      // return id > current_id;
      return true;
    },
    itemStatusColorFactory(status) {
      const obj = this.sundry_item_order_item_statuses.find((n) => n.name === status)
      return obj ? obj.color : 'dark'
    },
    async onClickChangeItemStatus(id, status) {
      await this.$vs.loading({
        container: '#sundry-order-item-table',
        scale: 0.45
      })
      try {
        const payload = { status: status }
        await SundrySupplierRepository.sundryOrderItemStatusChange(id, payload)
        await this.getSundryItemOrderDetails()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#sundry-order-item-table > .con-vs-loading')
    },
    async getSundryItemOrderDetails() {
      await this.$vs.loading({
        container: '#sundry-order-item-table',
        scale: 0.45
      })
      try {
        const { data } = (await SundrySupplierRepository.getSundryOrder(this.id)).data
        this.sundry_items = data.sundry_items
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#sundry-order-item-table > .con-vs-loading')
    },
    async onClickAddStock(item, qc_test_id) {
      await this.$refs.createSundryItemInventoryPopUp.openPopup(item, qc_test_id)
    },
    async onClickViewStock(id) {
      await this.$refs.updateSundryStockPopUp.openPopup(id)
    },
    async onClickUpdateQcTest(data) {
      await this.$refs.viewQcTestSundryOrderItemPopUp.openPopup(data)
    },
    async onClickPrintLabel(inventory_id) {
      await this.$refs.sundryOrderItemLabelPopUp.openPopup(inventory_id)
    }
  },
  watch: {
    items: function (new_value, old_value) {
      this.sundry_items = new_value
    }
  }
}
</script>

<
<style lang="scss">
.dropdown-button-container {
  display: flex;
  align-items: center;

  .btnx {
    border-radius: 5px 0px 0px 5px;
  }

  .btn-drop {
    border-radius: 0px 5px 5px 0px;
    border-left: 1px solid rgba(255, 255, 255, .2);
  }
}
</style>

